<template>
  <v-dialog v-model="dialog" max-width="900" max-height="600">
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>Create new checklist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-radio-group :disabled="checklistId !== null" v-model="checklistType" row class="mt-8" @change="onTypeChanged">
          <v-radio label="Business" value="business"></v-radio>
          <v-radio label="Personal" value="personal"></v-radio>
        </v-radio-group>
        <v-spacer></v-spacer>
        <v-btn v-if="checklistId" @click.stop="update" text class="mt-3">Save</v-btn>
        <v-btn v-else @click.stop="create" text class="mt-3">Save</v-btn>
        <v-btn @click.stop="close" text class="mt-3">Close</v-btn>
      </v-toolbar>
      <v-card-text :style="$vuetify.breakpoint.xsOnly ? 'padding:4px' : ''">
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="6">Question</v-col>
              <v-col cols="2">Provided</v-col>
              <v-col cols="4">Notes</v-col>
            </v-row>
            <v-row v-for="item in checklistFields" :key="item.id">
              <v-col cols="6">
                <v-textarea rows=4 v-model="item.detail" disabled></v-textarea>
              </v-col>
              <v-col cols="2">
                <v-checkbox v-model="item.checked"></v-checkbox>
              </v-col>
              <v-col cols="4">
                <v-textarea rows=4 v-model="item.notes"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import ChecklistService from '@/services/ChecklistService'

const ChecklistModule = namespace('checklist')

@Component
export default class CreateChecklistDialog extends Vue {
  @Prop(Number) entityId
  checklistId = null
  dialog = false
  loaded = false
  checklistType = null
  allChecklistFields = []
  checklistFields = []
  @ChecklistModule.Getter fields

  mounted () {
    this.loaded = true
    setTimeout(() => {
      ChecklistService.checklist_template_items()
        .then(resp => {
          this.allChecklistFields = resp.data.results || resp.data
        })
    }, 100)
  }

  open (checklist = null) {
    if (checklist) {
      this.checklistFields = checklist.items
      this.checklistId = checklist.id
    } else {
      this.checklistFields = []
    }
    this.dialog = true
  }

  close () {
    this.dialog = false
    this.checklistId = null
  }

  onTypeChanged () {
    this.checklistFields = this.allChecklistFields.filter(fld => fld.template_type === this.checklistType)
  }

  create () {
    const data = {
      items: this.checklistFields
    }
    ChecklistService.create(this.entityId, data)
      .then(resp => {
        this.$emit('checklist-added')
        this.close()
      })
  }

  update () {
    const data = {
      items: this.checklistFields
    }
    ChecklistService.update_items(this.checklistId, data)
      .then(resp => {
        this.close()
      })
  }
}
</script>
